import {
  Button,
  Dialog,
  Box,

} from "@material-ui/core"
import SendEmails from "../SendEmails"
import React, { useState } from "react"
import CloseIcon from "@material-ui/icons/Close"
import SendIcon from "@material-ui/icons/Send"
import { makeStyles } from "@material-ui/core/styles"


const useStyles = makeStyles(theme => ({
  dialogButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    marginRight: theme.spacing(1),
  },
  closeButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
}))


interface SendEmailDialogParams {
  open: boolean
  list: string[]  // Claim ids
  handleClose: () => void
}

function SendEmailDialog (
  { open, list, handleClose }: SendEmailDialogParams,
) {
  const classes = useStyles()
  return (
    <Dialog
      fullScreen
      open={open}
    >
      <Box className={classes.closeButton}>
        <Button
          size='large'
          color='inherit'
          variant='text'
          endIcon={<CloseIcon />}
          onClick={() => handleClose()}
        >Close
        </Button>
      </Box>
      <Box m={4}>
        {/* @ts-expect-error */}
        <SendEmails list={list} />
      </Box>
    </Dialog>
  )
}


interface SendButtonParams {
  selectedIds: string[]
  [key: string]: any
}

export default function SendBulkEmailButton (
  { selectedIds, ...props }: SendButtonParams,
) {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  return (
    <>
      <SendEmailDialog
        open={open}
        list={selectedIds}
        handleClose={() => setOpen(false)}
      />
      <Button
        startIcon={<SendIcon />}
        variant='outlined'
        onClick={() => setOpen(true)} className={classes.dialogButton}
      >
        Send Emails
      </Button>
    </>
  )
}
